import { ShowProps } from './Show.props';

export const Show = (props: ShowProps) =>
  props.if ? <>{props.children}</> : null;
